<template>
  <sidebar @close="close">
    <template v-slot:head>        
      <div class="container has-text-centered"> 
        <img width="96" height="96" :src="img" />
        <h2 class="title is-4">
          PayControl
        </h2>
      </div>
    </template>
    <template v-slot:body >
      <div v-if="qr !== '' && !state.configured" class="container has-text-centered">
        <div class="field">
          <figure class="avatar">
            <img :key="qr" id="qr" :src="qrBase + qr" />
          </figure>
        </div>
      </div>
      <div v-if="state.canRequestQr && !qr" class="button is-link is-fullwidth" @click="getQr">
        <span>{{ $t('auth_factors.payControl_connect') }}</span>
      </div>
      <div class="container has-text-centered" v-if="state.configured">
        <div style="text-align: center; margin-bottom: 0.5em;">{{ $t('auth_factors.payControl_configured') }}</div>
        <div class="button is-fullwidth" @click="disconnect">
          <span>{{ $t('auth_factors.payControl_disconnect') }}</span>
        </div>
      </div>
    </template>

  </sidebar>    
</template>

<script>
import paycontrolService from "@/services/paycontrol";
import Sidebar from "@/components/Sidebar";
export default {
  name: "PayControlDetails",
  components: {
    Sidebar
  },
  props: {
    payControl: {
      required: true
    },
    img: {
      required: true
    }
  },
  data() {
    return {
        qrUrl: paycontrolService.qrUrl,
        qrBase: "data:image/png;base64,",
        qr: "",
        error: "",
        invalid: false,
        polling: undefined,
        state: {
          active: false,
          configured: false,
          canRequestQr: false,
        }
    };
  },
  created: function() {
    this.pollState()
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },
  methods: {
    getQr() {
      paycontrolService.getQr().then(resp => {
        this.qr = resp.data
      })
    },
    getState(){
      paycontrolService.getState().then(resp => {
        this.state = resp.data
      })
    },
    disconnect() {
      paycontrolService.disconnect().then(() => this.getState()).catch(() => this.getState())
    },
    pollState () {
      if (typeof this.polling != "undefined") {
        clearInterval(this.polling)
      }
      this.getState()
      this.polling = setInterval(() => {
        this.getState()
      }, 4000)
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
